import React from "react";
import { Draggable } from "react-beautiful-dnd";

const NavBar = ({ 
    items,
    navClick,
    active,
    operation,
    handleOperationClick,
    provided,
}) => {
    return (
        <nav className="navbar navbar-expand-sm navbar-light bg-light">
            <div className="navbar-brand">Live</div>
            <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                    {items
                        ?.filter(item => item && item.ID)      // remove null or missing ID
                        .map((item, index) => (
                            <Draggable
                                key={item.ID}
                                draggableId={String(item.ID)}
                                index={index}
                            >
                                {(provided) => (
                                    <li
                                        className={item.ID === active.ID ? "nav-item active" : "nav-item"}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                    >
                                        <button
                                            className="btn btn-link nav-link"
                                            onClick={() => navClick(item)}
                                        >
                                            <span className="header-text">{item.DESCRIPTION}</span>
                                        </button>
                                        {/* Drag handle in the middle */}
                                        <span className="drag-handle" {...provided.dragHandleProps}>
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 100 20"
                                                fill="black">
                                                <polygon points="0,10 10,0 10,7 90,7 90,0 100,10 90,20 90,13 10,13 10,20" />
                                            </svg>
                                        </span>
                                    </li>
                                )}
                            </Draggable>
                        ))}
                </ul>
              {/* <ul className="navbar-nav text-white ml-auto">
              <li className={operation === "BC" ? "nav-item active" : "nav-item"}>
                <button
                  onClick={() => handleOperationClick("BC")}
                  className="btn btn-link nav-link"
                >
                  BC
                </button>
              </li>
              <li className={operation === "JR" ? "nav-item active" : "nav-item"}>
                <button
                  onClick={() => handleOperationClick("JR")}
                  className="btn btn-link nav-link"
                >
                  JR
                </button>
              </li>
            </ul> */}
            </div>
        </nav>
    );
};

export default NavBar;
